import { Actions } from 'libs/enums';
import { SecurityAction, SecurityGroupAction } from './securityaction';


export const Resources = {
  Locations: '1.1',
  Locations_LocationUsers: '1.1.6',
  Locations_Batch_Change_Status: '1.1.7',
  Object: '1.2',
  Objects_MaintenanceInspections: '1.2.3',
  Objects_Measurements: '1.2.4',
  Objects_ChangeObjectMIPlanSchemes: '1.2.11',
  Objects_Batch_Change_Status: '1.2.13',
  Objects_Batch_Change_Owner: '1.2.14',
  Objects_Batch_Change_Selection_Code: '1.2.15',
  Objects_Batch_Add_To_MoveBasket: '1.2.16',
  Objects_Attach_Object: '1.2.17',
  Objects_Batch_Change_Condition: '1.2.19',
  Objects_CopyObject: '1.2.18',
  Objects_MeterReadingSchedules: '1.2.20',
  Objects_MoveLogs: '1.2.21',
  Objects_ChangeMedia: '1.2.12',
  Objects_ChangeImage: '1.2.9',
  Product: '1.3',
  Products_Manage_Alternatives: '1.3.2',
  Products_Manage_Crosslinks: '1.3.3',
  Products_Manage_Suppliers: '1.3.4',
  Products_Access_To_Documents: '1.3.6',
  Products_Access_To_Dashboard: '1.3.8',
  Products_Manage_StockRevaluations: '1.3.9',
  Products_ManageProductSystemSettings: '1.3.10',
  ObjectCode: '1.4.1.2.9', // Maintenance_System_Object_ObjectCodes
  Maintenance_System_Websites: '1.4.1.19',
  Maintenance_System_OrderTemplates: '1.4.1.21',
  Relations_Persons: '1.23',
  WorkFlows: '1.18',
  HourCalculations: '1.24',
  ProductCalculations: '1.25',
  HourRegistrations: '1.26',
  ProductRealizations: '1.27',
  WorkFlows_Trade: '1.18.15',
  WorkFlows_AccessToPrivateConversations: '1.18.7',
  WorkFlows_ApproveWFIWorkingticket: '1.18.9',
  WorkFlows_ProcessWFIWorkingticket: '1.18.10',
  WorkFlows_RelatedWorkflowItem: '1.18.11',
  WorkFlows_ChangeRelatedWorkflow: '1.18.12',
  WorkFlows_AccessToFormalDescriptions: '1.18.13',
  WorkFlows_AccessToConversations: '1.18.14',
  WorkingTickets: '1.28',
  Journals: '1.29',
  WorkFlows_AllowImportConversations: '1.18.16',
  WorkFlows_StatusLogs: '1.18.17',
  WorkFlows_AccessToDashboard: '1.18.18',
  Invoices: '1.19',
  Contract: '1.20',
  Projects: '1.21',
  ProjectDashboard: '1.21.2',
  ProjectHourRealisation: '1.21.4',
  ProjectHourCalculation: '1.21.5',
  ProjectProductRealisation: '1.21.6',
  ProjectProductCalculation: '1.21.7',
  Projects_AccessToDocuments: '1.21.8',
  Projects_ManageProjectBudgetCodes: '1.21.9',
  CentixWeb_ChangeSystemViews: '3.11',
  CentixWeb_ChangeUserViews: '3.12',
  CentixWeb_AccessToOrderTemplates: '3.15',
  CentixWeb_AccessToDevices: '3.16',
  Administrators_Security_Groups: '99.4',
  IdentityProvider: '99.5',
  Administrators_Session_User_Graphics: '99.9',
  Administrators_Session_User_Log: '99.8',
  Administrators_Access_To_Users: '99.10',
  Administrators_Logs : '99.18',
  Maintenance_System_General_TeamRoles: '1.4.1.6.4',
  Relations: '1.6',
  WorkFlows_AccessToDocuments: '1.18.6',
  CentixWeb_AccessToPersons: '3.14.20',
  CentixWeb_AccessToReceipts: '3.14.21',
  Persons_ManageSecurity: '1.23.14',
  Persons_ManageLocationUsers: '1.23.13',
  Persons_ManageAdministrations: '1.23.12',
  Persons_ManageRelations: '1.23.11',
  Persons_ManageSettings: '1.23.10',
  Persons_AccessToDocuments: '1.23.9',
  Persons_ManageSignature: '1.23.8',
  Persons_ManagePhoto: '1.23.7',
  Persons_AccessToProfile: '1.23.2',
  Persons_AccessToProductivityStandard: '1.23.3',
  Orders_Order: '1.8',
  Orders_AccessToBaskets: '1.8.2',
  Orders_Basket_ChangeStatusToOrder: '1.8.2.1',
  Orders_Basket_ChangeStatusToOfferRequest: '1.8.2.2',
  Orders_Basket_ChangeStatusToNotAuthorized: '1.8.2.3',
  Orders_AccessToOfferRequest: '1.8.3',
  Orders_OfferRequest_ChangeStatusToOrder: '1.8.3.1',
  Orders_OfferRequest_ChangeStatusToNotAuthorized: '1.8.3.2',
  Orders_OfferRequest_ChangeStatusToRefusedOfferRequests: '1.8.3.3',
  Orders_AccessToNotAuthorized: '1.8.4',
  Orders_NotAuthorized_ChangeStatusToAuthorized: '1.8.4.1',
  Orders_NotAuthorized_ChangeStatusToRefused: '1.8.4.2',
  Orders_AccessToOrder: '1.8.5',
  Orders_Order_ChangeStatusToBasket: '1.8.5.1',
  Orders_Order_ChangeStatusToOfferRequest: '1.8.5.2',
  Orders_Order_ChangeStatusToNotAuthorized: '1.8.5.3',
  Orders_Order_ChangeStatusToCancelled: '1.8.5.4',
  Orders_AccessToRentalOutstanding: '1.8.7',
  Orders_AccessToCompleted: '1.8.8',
  Orders_AccessToCancelled: '1.8.9',
  Orders_AccessToRefused: '1.8.10',
  Orders_Refused_ChangeStatusToNotAuthorized: '1.8.10.1',
  Orders_AccessToRefusedOfferRequests: '1.8.11',
  Orders_RefusedOfferRequests_ChangeStatusToBasket: '1.8.11.1',
  Orders_RefusedOfferRequests_ChangeStatusToOfferRequest: '1.8.11.2',
  Orders_RefusedOfferRequests_ChangeStatusToNotAuthorized: '1.8.11.3',
  Orders_AccessToWorkflowItems: '1.8.12',
  Orders_AccessToDashboard: '1.8.13',
  Orders_PickList: '1.8.14',
  Orders_PackList: '1.8.15',
  Orders_ReturnEntry: '1.8.16',
  Orders_ReturnList: '1.8.17',
  Orders_StatusLogs: '1.8.18',
  Users: '1.5.1',
  CentixWeb_ProcessNewUserRequests: '3.1',
  CentixWeb_BackOffice: '3.14',
  CentixWeb_BackOffice_Products: '3.14.2',

  CentixSystemTables: '8.0',
  CentixSystemTables_ManageTransportMethod: '8.1',
  CentixSystemTables_ManageTeams: '8.2',
  CentixSystemTables_ManageSuppliers: '8.3',
  CentixSystemTables_ManageBudgetCodes: '8.4',
  CentixSystemTables_ManageObjectOIAutoResponseSettings: '8.5',
  CentixSystemTables_ManageUserAutoResponseSettings: '8.6',
  CentixSystemTables_ManageLocationTypes: '8.7',
  CentixSystemTables_ManageReportDefinitions: '8.8',
  CentixSystemTables_ManageObjectTypes: '8.9',
  CentixSystemTables_ManageMIPlans: '8.10',
  CentixSystemTables_ManageMoveBasketAutoResponderSetting: '8.11',
  CentixSystemTables_ManageObjectCodes: '8.12',
  CentixSystemTables_ManageWorkableDays: '8.13',
  CentixSystemTables_ManagePriceLists: '8.14',
  CentixSystemTables_ManageAdministrations : '8.15',
  CentixSystemTables_ManageContractTypes: '8.16',
  CentixSystemTables_ManageContractAutoresponseSettings: '8.17',
  CentixSystemTables_ManageNewUserrequestsAutoresponseSettings: '8.18',
  CentixSystemTables_ManagePurchaseOrderAutoresponseSettings: '8.19',
  CentixSystemTables_ManageInvoiceAutoresponseSettings: '8.20',
  CentixSystemTables_ManagePurchaseInvoiceAutoresponseSettings: '8.21',
  CentixSystemTables_ManageManageFixedAssetGroups: '8.22',
  CentixSystemTables_ManageBookYears: '8.23',
  CentixSystemTables_ManageOrderCosts: '8.24',
  CentixSystemTables_ManageTransportCosts: '8.25',
  CentixSystemTables_LocationAutoResponderSettings: '8.26',
  CentixSystemTables_WorkingTicketAutoResponderSettings: '8.27',
  CentixSystemTables_ManageEmailTemplates: '8.28',
  CentixSystemTables_ManageMeterreadings: '8.29',
  CentixSystemTables_ManageWorkflowGroups: '8.30',
  CentixSystemTables_ManageCountryStateCounty: '8.31',
  CentixSystemTables_ManageLists: '8.32',
  CentixSystemTables_ManageWorkflowAutoresponderSettings: '8.33',
  CentixSystemTables_ManageBrandTypesRevisions : '8.34',
  CentixSystemTables_ManageQuantitiesUnits : '8.35',
  CentixSystemTables_ManageInspectionNorm : '8.36',
  CentixSystemTables_ManageVat : '8.37',
  CentixSystemTables_ManageReasons : '8.38',
  CentixSystemTables_ManageReturnRequestAutoresponseSettings : '8.39',
  CentixSystemTables_ManageWorkflowServiceLevel : '8.40',
  CentixSystemTables_ManageWorkFlowPriority : '8.41',
  CentixSystemTables_ManageContractIndex : '8.42',
  CentixSystemTables_ManagePackListAutoResponderSetting : '8.43',
  CentixSystemTables_ManageReturnListAutoResponderSetting : '8.44',
  CentixSystemTables_ManageMIWorkFlowSetting : '8.45',
  CentixSystemTables_ManageOrderAutoResponderSetting : '8.46',
  CentixSystemTables_ManageLocationStatuses:"8.47",
  CentixSystemTables_ManageProductStatuses:"8.48",
  CentixSystemTables_ManagePersonStatuses:"8.49",
  CentixSystemTables_ManageProjectStatuses:"8.50",
  CentixSystemTables_ManageRelationStatuses:"8.51",
  CentixSystemTables_ManageObjectStatuses:"8.52",
  CentixSystemTables_ManageRelationContractStatuses:"8.53",
  CentixSystemTables_ManageDocumentKinds: "8.54",
  CentixSystemTables_ManageMovePos: "8.55",
  CentixSystemTables_ManageFormConfigurations: "8.56",
  CentixSystemTables_ManageMeasuringDeviceBrandAndType: "8.57",
  CentixSystemTables_ManageProjectAutoResponderSetting : '8.58',
  CentixSystemTables_ManageHourkind: "8.59",
  CentixSystemTables_ManagePropertyGroups: "8.60",
  CentixSystemTables_ManageWorkPlace: "8.65",
  CentixSystemTables_ManageRentalRateCode: "8.66",
  CentixSystemTables_ManageArticleUnits: "8.70",
  CentixSystemTables_ManageCrossLinkTypes: "8.71",
  CentixSystemTables_ManageIDGeneratorSettings: "8.72",
  CentixSystemTables_ManageObjectGroups: "8.73",
  CentixSystemTables_ManageConditions: "8.74",
  CentixSystemTables_ManageLockReasons: "8.75",
  CentixSystemTables_ManageTimeSchedules: "8.76",
  CentixSystemTables_ManageCompetences: "8.79",
  CentixSystemTables_ManageAddressGroups: "8.81",
  CentixSystemTables_ManageBlockReasons: "8.82",
  CentixSystemTables_ManageLanguages: "8.83",
  CentixSystemTables_ManagePaymentMethods: "8.84",
  CentixSystemTables_ManagePaymentConditions: "8.85",
  CentixSystemTables_ManageRelationGroups: "8.86",
  CentixSystemTables_ManageFlowStatuses: "8.87",
  CentixSystemTables_ManageWorkingTicketStatusses: "8.88",
  CentixWeb_BackOffice_Projects: '3.14.1',
  Projects_ManageTeams: '1.21.3',
  ChangeInspectionCompanyInspector: '1.10.3',
  ChangeMIScheduleTimeSchedule: '1.10.8',
  ChangeInspectionLocation: '1.10.9',
  Manage_Warehouses: '1.4.1.20',
  Access_to_warehouses: '3.14.6',
  Access_to_Orderbaskets: '3.14.33',
  OrderBaskets: '1.32',
  AllowRentalOutstanding: '1.32.2',
  AccessToOtherUsersOrderBaskets: '1.32.3',
  AccessToProcessedOrderBaskets: '1.32.4',
  IoT_ManageDevices: '1.33.1',
  IoT_Geofences: '1.33.2',
  
  RecurringWorkFlow: '1.34',
  RecurringWorkFlow_AccessToHourCalculations: '1.34.2',
  RecurringWorkFlow_AccessToWorkFlow: '1.34.3',
  RecurringWorkFlow_AccessToDocuments: '1.34.4',

  WorkflowTemplate: '1.35',
  WorkflowTemplate_AccessToHourCalculations: '1.35.2',
  WorkflowTemplate_AccessToWorkFlow: '1.35.3',
  WorkflowTemplate_AccessToDocuments: '1.35.4',

  CentixWeb_AccessToOrders: '3.14.5',
  Documents: '1.22',
  Relations_AccessToProfile: '1.6.4',
  Relations_AccessToInvoiceSettings: '1.6.5',
  Relations_AccessToFinancialSettings: '1.6.6',
  Relations_Manage_Addresses: '1.6.7',
  Relations_Access_To_Order_Settings: '1.6.8',
  Relations_Access_To_Purchase_Order_Settings: '1.6.9',
  Relations_Access_To_Web_Settings: '1.6.10',
  Relations_ManageConcernRelations: '1.6.11',
  Relations_ManageDocuments: '1.6.12',
  Relations_AccessDashboard: '1.6.13',
  CentixWeb_AccessToRelations: '3.14.7',
  CentixWeb_GenericFunctionality: '3.0.1',
  CentixWeb_AccessToMIPrintWizard: '3.0.1.1',
  CentixWeb_AccessToWFIForObjectMIScheduleCreateWizar: '3.0.1.2',
  CentixWeb_AccessToObjectMIForObjectMIScheduleCreateWizar: '3.0.1.3',
  CentixWeb_AllowExportUsingImportLayout: '3.0.1.4',
  CentixWeb_AllowExportUsingGridLayout: '3.0.1.5',
  WorkflowManagement_ManageHourRealizations: '1.18.2',
  WorkflowManagement_ManageHourCalculations: '1.18.3',
  WorkflowManagement_ManageProductRealizations: '1.18.4',
  WorkflowManagement_ManageProductCalculations: '1.18.5',
  WorkingTickets_ManageHourRealizations: '1.28.2',
  WorkingTickets_ManageProductRealizations: '1.28.3',
  WorkingTickets_DashboardAccess: '1.28.8' ,
  WorkingTickets_AccessToDocuments: '1.28.9' ,
	WorkingTickets_ManageMIAttachment: '1.28.10' ,
  CentixWeb_AccessToWorkflowItems: '3.14.10',
  CentixWeb_AccessToWorkingTickets: '3.14.11',
  WorkingTickets_AccessToLogs: '1.28.4',
  WorkingTickets_ManageSignature: '1.28.5',
  WorkingTickets_ManagePersons: '1.28.6',
  WorkingTickets_ManageWorkflow: '1.28.7',
  Contracts_AccessToDocuments: '1.20.2',
  Contracts_AccessToInvoices: '1.20.3',
  Contracts_AccessToLogs: '1.20.4',
  Contracts_AccessToDashboard: '1.20.5',
  CentixWeb_AccessToContracts: '3.14.12',
  CentixWeb_AccessToPurchaseOrders: '3.14.13',
  PurchaseOrders_PurchaseOrder: '1.9',
  PurchaseOrders_AccessToConcept: '1.9.2',
  PurchaseOrders_Concept_ChangeStatusToOrder: '1.9.2.1',
  PurchaseOrders_Concept_ChangeStatusToOfferRequest: '1.9.2.2',
  PurchaseOrders_Concept_ChangeStatusToNotAuthorized: '1.9.2.3',
  PurchaseOrders_AccessToOfferRequest: '1.9.3',
  PurchaseOrders_OfferRequest_ChangeStatusToOrder: '1.9.3.1',
  PurchaseOrders_OfferRequest_ChangeStatusToNotAuthorized: '1.9.3.2',
  PurchaseOrders_AccessToNotAuthorized: '1.9.4',
  PurchaseOrders_NotAuthorized_ChangeStatusToAuthorized: '1.9.4.1',
  PurchaseOrders_NotAuthorized_ChangeStatusToRefused: '1.9.4.2',
  PurchaseOrders_AccessToOrder: '1.9.5',
  PurchaseOrders_Order_ChangeStatusToBasket: '1.9.5.1',
  PurchaseOrders_Order_ChangeStatusToOfferRequest: '1.9.5.2',
  PurchaseOrders_Order_ChangeStatusToNotAuthorized: '1.9.5.3',
  PurchaseOrders_AccessToCompleted: '1.9.6',
  PurchaseOrders_AccessToRefused: '1.9.7',
  PurchaseOrders_Refused_ChangeStatusToNotAuthorized: '1.9.7.1',
  PurchaseOrders_ManageReceipts: '1.9.8',
  PurchaseOrders_AccessToWorkFlowItems: '1.9.9',
  PurchaseOrders_AccessToLogs: '1.9.10',
  PurchaseOrders_AccessToDashboard: '1.9.11',
  Invoices_AccessToWorkFlow: '1.19.3',
  Invoices_AccessToLogs: '1.19.4',
  Invoices_AccessToDashboard: '1.19.5',
  CentixWeb_AccessToInvoices: '3.14.15',
  CentixWeb_AccessToJournals: '3.14.17',
  SystemSettings: '1.11',
  Competences : '1.12',
  WorkFlows_ManageFixedWork: '1.18.19',
  WorkFlows_ManageWorkflowUsers: '1.18.20',
  WorkFlows_ManageWorkflowPackLists: '1.18.21',
  Administrators_ContentLanguages: '99.2',
  Administrators_DatabaseSettings: '99.12',
  Administrators_WorkFlow_PositionNumber_Correction: '99.13',
  Administrators_ManageLogSettings: '99.15',
  ObjectMI_AccessToLogs: '1.10.4',
  CentixWeb_AccessToPurchaseInvoices: '3.14.18',
  PurchaseInvoices: '1.30',
  PurchaseInvoices_AccessToWorkflow: '1.30.2',
  PurchaseInvoices_AccessToDocuments: '1.30.3',
  PurchaseInvoices_AccessToLogs: '1.30.4',
  CentixWeb_AccessToProductStockPurchase: '3.14.19',
  CentixWeb_AccessToPickLists: '3.14.8',
  CentixWeb_AccessToRecurringWorkFlowItems: '3.14.23',
  CentixWeb_AccessToWorkflowTemplates: '3.14.43',
  MaintenanceInspection_AllowObjectConditionChange: '1.10.5',
  MaintenanceInspection_AllowCertificateUpload: '1.10.6',
  MaintenanceInspection_AccessToDocuments: '1.10.7',
  CentixWeb_AccessToCapacityPlanning: '3.14.24',
  CentixWeb_AccessToProductStockRevaluation: '3.14.25',
  CentixWeb_AccessToCompetences: '3.14.26',
  CentixWeb_AccessToPackLists: '3.14.9',
  CentixSystemSettings_ManagePersonSystemSettings: '7.8',
  CentixSystemSettings_ManageRelationSystemSettings: '7.9',
  CentixSystemSettings_ManageWorkingTicketSystemSettings: '7.11',
  CentixSystemSettings_ManageOrderSystemSettings: '7.12',
  CentixSystemSettings_ManageWorkFlowSystemSettings: '7.14',
  CentixWeb_AccessToReturnRequests: '3.14.28',
  CentixWeb_AccessToEInvoices: '3.14.29',
  CentixWeb_AccessToDepreciations: '3.14.30',
  CentixWeb_AccessToStocks: '3.14.31',
  CentixWeb_AccessToMovePos: '3.14.32',
  CentixWeb_AccessToProductRealizations: '3.14.34',
  Returns: '1.31',
  ReturnRequests: '1.31.1',
  ReturnRequests_AccessToConcept: '1.31.1.2',
  ReturnRequests_ChangeConceptToSubmitted: '1.31.1.2.1',
  ReturnRequests_AccessToSubmitted: '1.31.1.3',
  ReturnRequests_ChangeSubmittedToAccepted: '1.31.1.3.1',
  ReturnRequests_ChangeSubmittedToDenied: '1.31.1.3.2',
  ReturnRequests_ChangeSubmittedToCancelled: '1.31.1.3.3',
  ReturnRequests_AccessToAccepted: '1.31.1.4',
  ReturnRequests_ChangeAcceptedToConcept: '1.31.1.4.1',
  ReturnRequests_ChangeAcceptedToCancelled: '1.31.1.4.2',
  ReturnRequests_AccessToDenied: '1.31.1.5',
  ReturnRequests_ChangeDeniedToConcept: '1.31.1.4.1',
  ReturnRequests_ChangeDeniedToCancelled: '1.31.1.4.2',
  ReturnRequests_AccessToCancelled: '1.31.1.6',
  MoveBasket: '1.7',
  AccessToOtherUsersMovebaskets: '1.7.2',
  AccessToProcessedMovebaskets: '1.7.3',
  AccessToLogs: '1.7.4',
  AccessToDocuments: '1.7.5',
  DistributionBoards: '1.10.10',
  OtherPeoplesDistributionBoards: '1.10.10.1',
  Locations_ChangeImage: '1.1.4',
  Locations_ChangeMedia: '1.1.5',
  CentixWeb_AccessToR2M: '3.14.35',
  CentixWeb_AccessToR2M_Logs: '3.14.36',
  CentixWeb_AccessToR2M_Recipient_Logs: '3.14.37',
  CentixWeb_R2M_AccessToMovements: '3.14.38',
  CentixWeb_R2M_AccessToReceivers: '3.14.39',
  Projects_AccessToLogs: '1.21.10',
  Administrators_AuthorisedToSign : '99.17',
	Invoices_ChangeInvoiceToVoided: '1.19.6',
	Objects_Access_To_Notification_Recipients: '1.2.22',
	Relations_Access_To_Notification_Recipients: '1.6.14',
	Locations_Access_To_Notification_Recipients: '1.1.9',
	CentixWeb_Access_To_ObjectAlert_Emails: '3.14.40',
  CentixWeb_Access_To_Documents: '3.14.42',
	Administrators_ManageWebPages: "99.20",
};


/** CRUD actions */

export const R2M = {
  CentixWeb_AccessToR2M : new SecurityAction(Resources.CentixWeb_AccessToR2M, Actions.Execute),
  CentixWeb_AccessToR2M_Logs : new SecurityAction(Resources.CentixWeb_AccessToR2M_Logs, Actions.Execute),
  CentixWeb_AccessToR2M_Recipient_Logs : new SecurityAction(Resources.CentixWeb_AccessToR2M_Recipient_Logs, Actions.Execute),
  CentixWeb_AccessToR2M_AccessToMovements : new SecurityAction(Resources.CentixWeb_R2M_AccessToMovements, Actions.Execute),
  CentixWeb_R2M_AccessToReceivers : new SecurityAction(Resources.CentixWeb_R2M_AccessToReceivers, Actions.Execute)
};

export const PickList = {
  PickLists : new SecurityGroupAction(Resources.Orders_PickList),
  AccessToPickLists : new SecurityAction(Resources.CentixWeb_AccessToPickLists, Actions.Execute)
};
export const PackList = {
  PackLists : new SecurityGroupAction(Resources.Orders_PackList),
  AccessToPackLists : new SecurityAction(Resources.CentixWeb_AccessToPackLists, Actions.Execute)
};
export const ObjectCode = new SecurityGroupAction(Resources.ObjectCode);
export const MaintenanceSystemWebsites = new SecurityGroupAction(
  Resources.Maintenance_System_Websites
);
export const User = new SecurityGroupAction(Resources.Users);
export const Projects = new SecurityGroupAction(Resources.Projects);

export const Orders = {
  BackOfficeOrders: new SecurityAction(Resources.CentixWeb_AccessToOrders, Actions.Execute),
  Orders: new SecurityGroupAction(Resources.Orders_Order),
  
  AccessToBaskets : new SecurityAction(Resources.Orders_AccessToBaskets, Actions.Execute),
  Basket_ChangeStatusToOrder : new SecurityAction(Resources.Orders_Basket_ChangeStatusToOrder, Actions.Execute),
  Basket_ChangeStatusToOfferRequest : new SecurityAction(Resources.Orders_Basket_ChangeStatusToOfferRequest, Actions.Execute),
  Basket_ChangeStatusToNotAuthorized : new SecurityAction(Resources.Orders_Basket_ChangeStatusToNotAuthorized, Actions.Execute),
  AccessToOfferRequest : new SecurityAction(Resources.Orders_AccessToOfferRequest, Actions.Execute),
  OfferRequest_ChangeStatusToOrder : new SecurityAction(Resources.Orders_OfferRequest_ChangeStatusToOrder, Actions.Execute),
  OfferRequest_ChangeStatusToNotAuthorized : new SecurityAction(Resources.Orders_OfferRequest_ChangeStatusToNotAuthorized, Actions.Execute),
  OfferRequest_ChangeStatusToRefusedOfferRequests : new SecurityAction(Resources.Orders_OfferRequest_ChangeStatusToRefusedOfferRequests, Actions.Execute),
  AccessToNotAuthorized : new SecurityAction(Resources.Orders_AccessToNotAuthorized, Actions.Execute),
  NotAuthorized_ChangeStatusToAuthorized : new SecurityAction(Resources.Orders_NotAuthorized_ChangeStatusToAuthorized, Actions.Execute),
  NotAuthorized_ChangeStatusToRefused : new SecurityAction(Resources.Orders_NotAuthorized_ChangeStatusToRefused, Actions.Execute),
  AccessToOrder : new SecurityAction(Resources.Orders_AccessToOrder, Actions.Execute),
  Order_ChangeStatusToBasket : new SecurityAction(Resources.Orders_Order_ChangeStatusToBasket, Actions.Execute),
  Order_ChangeStatusToOfferRequest : new SecurityAction(Resources.Orders_Order_ChangeStatusToOfferRequest, Actions.Execute),
  Order_ChangeStatusToNotAuthorized : new SecurityAction(Resources.Orders_Order_ChangeStatusToNotAuthorized, Actions.Execute),
  Order_ChangeStatusToCancelled : new SecurityAction(Resources.Orders_Order_ChangeStatusToCancelled, Actions.Execute),
  AccessToRentalOutstanding : new SecurityAction(Resources.Orders_AccessToRentalOutstanding, Actions.Execute),
  AccessToCompleted : new SecurityAction(Resources.Orders_AccessToCompleted, Actions.Execute),
  AccessToCancelled : new SecurityAction(Resources.Orders_AccessToCancelled, Actions.Execute),
  AccessToRefused : new SecurityAction(Resources.Orders_AccessToRefused, Actions.Execute),
  Refused_ChangeStatusToNotAuthorized : new SecurityAction(Resources.Orders_Refused_ChangeStatusToNotAuthorized, Actions.Execute),
  AccessToRefusedOfferRequests : new SecurityAction(Resources.Orders_AccessToRefusedOfferRequests, Actions.Execute),
  RefusedOfferRequests_ChangeStatusToBasket : new SecurityAction(Resources.Orders_RefusedOfferRequests_ChangeStatusToBasket, Actions.Execute),
  RefusedOfferRequests_ChangeStatusToOfferRequest : new SecurityAction(Resources.Orders_RefusedOfferRequests_ChangeStatusToOfferRequest, Actions.Execute),
  RefusedOfferRequests_ChangeStatusToNotAuthorized : new SecurityAction(Resources.Orders_RefusedOfferRequests_ChangeStatusToNotAuthorized, Actions.Execute),
  AccessToWorkflowItems : [
    new SecurityAction(Resources.Orders_AccessToWorkflowItems, Actions.Execute),
    new SecurityAction(Resources.WorkFlows, Actions.Read)
  ],
  AccessToDashboard : new SecurityAction(Resources.Orders_AccessToDashboard, Actions.Execute),
  Orders_PickList : new SecurityAction(Resources.Orders_PickList, Actions.Execute),
  Orders_PackList : new SecurityAction(Resources.Orders_PackList, Actions.Execute),
  Orders_ReturnEntry : new SecurityAction(Resources.Orders_ReturnEntry, Actions.Execute),
  Orders_ReturnList : new SecurityAction(Resources.Orders_ReturnList, Actions.Execute),
  Orders_StatusLogs : new SecurityAction(Resources.Orders_StatusLogs, Actions.Execute)
};

export const Project = {
  Projects : new SecurityGroupAction(Resources.Projects),
  ProjectDashboard : new SecurityAction(Resources.ProjectDashboard, Actions.Execute),
  ManageTeams : new SecurityAction(Resources.Projects_ManageTeams, Actions.Execute),
  ProjectHourRealisation : new SecurityAction(Resources.ProjectHourRealisation, Actions.Execute),
  ProjectHourCalculation : new SecurityAction(Resources.ProjectHourCalculation, Actions.Execute),
  ProjectProductRealisation : new SecurityAction(Resources.ProjectProductRealisation, Actions.Execute),
  ProjectProductCalculation : new SecurityAction(Resources.ProjectProductCalculation, Actions.Execute),
  CentixWebBackOfficeProjects : new SecurityAction(Resources.CentixWeb_BackOffice_Projects, Actions.Execute),
  ProjectsAccessToDocuments: new SecurityAction(Resources.Projects_AccessToDocuments, Actions.Execute),
  ProjectsManageProjectBudgetCodes: new SecurityAction(Resources.Projects_ManageProjectBudgetCodes, Actions.Execute),
  ProjectsAccessToLogs: new SecurityAction(Resources.Projects_AccessToLogs, Actions.Execute)
};

export const Product = {
  Products: new SecurityGroupAction(Resources.Product),
  Manage_Alternatives: new SecurityAction(
    Resources.Products_Manage_Alternatives,
    Actions.Execute
  ),
  Manage_Crosslinks: new SecurityAction(
    Resources.Products_Manage_Crosslinks,
    Actions.Execute
  ),
  Manage_Suppliers: new SecurityAction(
    Resources.Products_Manage_Suppliers,
    Actions.Execute
  ),
  Access_To_Documents: new SecurityAction(
    Resources.Products_Access_To_Documents,
    Actions.Execute
  ),
  Access_To_Dashboard: new SecurityAction(
    Resources.Products_Access_To_Dashboard,
    Actions.Execute
  ),
  Manage_ProductSystemSettings: new SecurityAction(
    Resources.Products_ManageProductSystemSettings,
    Actions.Execute
  ),
  ProductDetail: [
    new SecurityAction(
      Resources.CentixWeb_BackOffice_Products,
      Actions.Execute
    ),
    new SecurityAction(Resources.Product, Actions.CreateOrUpdate)
  ]
};

/** Groups where subitems are CRUD actions */
export const WorkFlow = {
  WorkFlowItems: new SecurityGroupAction(Resources.WorkFlows),
  ProcessWorkingTicket: new SecurityAction(Resources.WorkFlows_ProcessWFIWorkingticket, Actions.Execute),
  AccessToConversations: new SecurityAction(Resources.WorkFlows_AccessToConversations, Actions.Execute),
  AccessToPrivateConversations: new SecurityAction(Resources.WorkFlows_AccessToPrivateConversations, Actions.Execute),
  ViewRelated: new SecurityAction(Resources.WorkFlows_RelatedWorkflowItem, Actions.Execute),
  ChangeRelated: new SecurityAction(Resources.WorkFlows_ChangeRelatedWorkflow, Actions.Execute),
  AccessToFormalDescriptions: new SecurityAction(Resources.WorkFlows_AccessToFormalDescriptions, Actions.Execute),
  AllowImportConversations: new SecurityAction(Resources.WorkFlows_AllowImportConversations, Actions.Execute),
  StatusLogs: new SecurityAction(Resources.WorkFlows_StatusLogs, Actions.Execute),
  AccessToDashboard: new SecurityAction(Resources.WorkFlows_AccessToDashboard, Actions.Execute),
  AccessToDocuments: new SecurityAction(Resources.WorkFlows_AccessToDocuments, Actions.Execute),
  ManageHourRealizations: new SecurityAction(Resources.WorkflowManagement_ManageHourRealizations, Actions.Execute),
  ManageHourCalculations: new SecurityAction(Resources.WorkflowManagement_ManageHourCalculations, Actions.Execute),
  ManageProductRealizations: new SecurityAction(Resources.WorkflowManagement_ManageProductRealizations, Actions.Execute),
  ManageProductCalculations: new SecurityAction(Resources.WorkflowManagement_ManageProductCalculations, Actions.Execute),
  AccessToWorkflowItems: new SecurityAction(Resources.CentixWeb_AccessToWorkflowItems, Actions.Execute),
  WorkFlows_Trade : new SecurityAction(Resources.WorkFlows_Trade, Actions.Execute),
  ManageFixedWork: new SecurityAction(Resources.WorkFlows_ManageFixedWork, Actions.Execute),
  ManageWorkflowUsers: new SecurityAction(Resources.WorkFlows_ManageWorkflowUsers, Actions.Execute),
  ManageWorkflowPackLists: new SecurityAction(Resources.WorkFlows_ManageWorkflowPackLists, Actions.Execute),

};

export const HourRegistrations = new SecurityGroupAction(Resources.HourRegistrations);
export const HourCalculations = new SecurityGroupAction(Resources.HourCalculations);
export const ProductRealizations = new SecurityGroupAction(Resources.ProductRealizations);
export const ProductCalculations = new SecurityGroupAction(Resources.ProductCalculations);

/** Deviants */
export const AccessToMIPrintWizard = {
  AccessToMIPrintWizard: new SecurityAction(Resources.CentixWeb_AccessToMIPrintWizard, Actions.Execute)
};
export const AccessToWFIForObjectMIScheduleCreateWizar = {
  AccessToWFIForObjectMIScheduleCreateWizar: new SecurityAction(Resources.CentixWeb_AccessToWFIForObjectMIScheduleCreateWizar, Actions.Execute)
};
export const AccessToObjectMIForObjectMIScheduleCreateWizar = {
  AccessToObjectMIForObjectMIScheduleCreateWizar: new SecurityAction(Resources.CentixWeb_AccessToObjectMIForObjectMIScheduleCreateWizar, Actions.Execute)
};
// // actually CRUD
// export const PurchaseReceipt = {
//   Create: new SecurityAction(Resources.PurchaseReceipt, Actions.Create),
//   Update: new SecurityAction(Resources.PurchaseReceipt, Actions.Update),
//   Read: new SecurityAction(Resources.PurchaseReceipt, Actions.Read),
//   Delete: new SecurityAction(Resources.PurchaseReceipt, Actions.Delete)
// };
export const PurchaseReceipt = {
  ManageReceipts: new SecurityAction(Resources.PurchaseOrders_ManageReceipts, Actions.Execute)
};

// actually CRUD
export const Contract = {
  Contracts: new SecurityGroupAction(Resources.Contract),
  AccessToDocuments: new SecurityAction(Resources.Contracts_AccessToDocuments, Actions.Execute),
  AccessToInvoices: new SecurityAction(Resources.Contracts_AccessToInvoices, Actions.Execute),
  AccessToLogs: new SecurityAction(Resources.Contracts_AccessToLogs, Actions.Execute),
  AccessToDashboard: new SecurityAction(Resources.Contracts_AccessToDashboard, Actions.Execute),
  AccessToContracts: new SecurityAction(Resources.CentixWeb_AccessToContracts, Actions.Execute),
};

export const Grid = {
  AllowChangeUserViews: new SecurityAction(
    Resources.CentixWeb_ChangeUserViews,
    Actions.Execute
  ),
  AllowChangeSystemViews: new SecurityAction(
    Resources.CentixWeb_ChangeSystemViews,
    Actions.Execute
  )
};

export const WorkingTicket = {
  WorkingTickets: new SecurityGroupAction(Resources.WorkingTickets),
  Approve: new SecurityAction(Resources.WorkFlows_ApproveWFIWorkingticket, Actions.Execute),
  Process: new SecurityAction(Resources.WorkFlows_ProcessWFIWorkingticket, Actions.Execute),
  AccessToWorkingTickets: new SecurityAction(Resources.CentixWeb_AccessToWorkingTickets, Actions.Execute),
  ManageHourRealizations: new SecurityAction(Resources.WorkingTickets_ManageHourRealizations, Actions.Execute),
  ManageHourCalculations: new SecurityAction(Resources.WorkingTickets_ManageHourCalculations, Actions.Execute),
  ManageProductRealizations: new SecurityAction(Resources.WorkingTickets_ManageProductRealizations, Actions.Execute),
  ManageProductCalculations: new SecurityAction(Resources.WorkingTickets_ManageProductCalculations, Actions.Execute),
  AccessToLogs: new SecurityAction(Resources.WorkingTickets_AccessToLogs, Actions.Execute),
  ManageSignature: new SecurityAction(Resources.WorkingTickets_ManageSignature, Actions.Execute),
  ManagePersons: new SecurityAction(Resources.WorkingTickets_ManagePersons, Actions.Execute),
  ManageWorkflow: new SecurityAction(Resources.WorkingTickets_ManageWorkflow, Actions.Execute),
  Dashboard: new SecurityAction(Resources.WorkingTickets_DashboardAccess, Actions.Execute),
  AccessToDocuments: new SecurityAction(Resources.WorkingTickets_AccessToDocuments, Actions.Execute),
	ManageMIAttachment: new SecurityAction(Resources.WorkingTickets_ManageMIAttachment, Actions.Execute),
};

export const Object = new SecurityGroupAction(Resources.Object);

export const ObjectBulkActions = {
  ChangeStatus: new SecurityAction(
    Resources.Objects_Batch_Change_Status,
    Actions.Execute
  ),
  ChangeOwner: new SecurityAction(
    Resources.Objects_Batch_Change_Owner,
    Actions.Execute
  ),
  ChangeSelectionCode: new SecurityAction(
    Resources.Objects_Batch_Change_Selection_Code,
    Actions.Execute
  ),
  AddToMoveBasket: new SecurityAction(
    Resources.Objects_Batch_Add_To_MoveBasket,
    Actions.Execute
  ),
  ChangeCondition: new SecurityAction(
    Resources.Objects_Batch_Change_Condition,
    Actions.Execute
  ),
};

export const ObjectLocationBulkActions = {
  ChangeStatus: new SecurityAction(
    Resources.Objects_Batch_Change_Status,
    Actions.Execute
  ),
  ChangeOwner: new SecurityAction(
    Resources.Objects_Batch_Change_Owner,
    Actions.Execute
  ),
  ChangeSelectionCode: new SecurityAction(
    Resources.Objects_Batch_Change_Selection_Code,
    Actions.Execute
  ),
  AddToMoveBasket: new SecurityAction(
    Resources.Objects_Batch_Add_To_MoveBasket,
    Actions.Execute
  ),
  ChangeCondition: new SecurityAction(
    Resources.Objects_Batch_Change_Condition,
    Actions.Execute
  ),
};

export const LocationsBulkActions = {
  ChangeStatus: new SecurityAction(
    Resources.Locations_Batch_Change_Status,
    Actions.Execute
  ),
  Update: new SecurityAction(Resources.Locations, Actions.Update),
  Delete: new SecurityAction(Resources.Locations, Actions.Delete)
};

export const ObjectLocationMISchedulesActions = {
  Create: new SecurityAction(
    Resources.Objects_MaintenanceInspections,
    Actions.Create
  ),
  Read: new SecurityAction(
    Resources.Objects_MaintenanceInspections,
    Actions.Read
  ),
  Delete: new SecurityAction(
    Resources.Objects_MaintenanceInspections,
    Actions.Delete
  )
};

export const ChangeObjectMIPlanSchemesActions = {
  ChangeObjectMIPlanSchemes: new SecurityAction(
    Resources.Objects_ChangeObjectMIPlanSchemes,
    Actions.Execute
  )
};

export const ReturnBasketEntryActions = {
  Delete: new SecurityAction(Resources.Orders_ReturnEntry, Actions.Delete)
};

export const Admin = {
  Read: new SecurityAction(Resources.IdentityProvider, Actions.Execute)
};

export const SessionStatistics = {
  Read: new SecurityAction(
    Resources.Administrators_Session_User_Graphics,
    Actions.Execute
  )
};

export const SessionUserLogs = {
  Read: new SecurityAction(
    Resources.Administrators_Session_User_Log,
    Actions.Execute
  )
};
export const AccessToUsers = {
  Read: new SecurityAction(
    Resources.Administrators_Access_To_Users,
    Actions.Execute
  )
};
export const AccessToLogs = {
  AccessToLogs: new SecurityAction(
    Resources.Administrators_Logs,
    Actions.Execute
  )
};


export const Invoices = {
  Invoice: new SecurityGroupAction(Resources.Invoices),
  AccessToWorkFlow:
  [ 
    new SecurityAction(Resources.Invoices_AccessToWorkFlow, Actions.Execute),
    new SecurityAction(Resources.WorkFlows, Actions.Read),
    new SecurityAction(Resources.CentixWeb_AccessToWorkflowItems, Actions.Execute),
  ],
  AccessToLogs: new SecurityAction(Resources.Invoices_AccessToLogs, Actions.Execute),
  AccessToDashboard: new SecurityAction(Resources.Invoices_AccessToDashboard, Actions.Execute),
  AccessToInvoices: new SecurityAction(Resources.CentixWeb_AccessToInvoices, Actions.Execute),
  ChangeInvoiceToVoided: new SecurityAction(Resources.Invoices_ChangeInvoiceToVoided, Actions.Execute)
};

export const Person = {
  Persons: new SecurityGroupAction(Resources.Relations_Persons),
  AccessToProfile: new SecurityAction(
    Resources.Persons_AccessToProfile,
    Actions.Execute
  ),
  AccessToProductivityStandard: new SecurityAction(
    Resources.Persons_AccessToProductivityStandard,
    Actions.Execute
  ),
  ManagePhoto: new SecurityAction(
    Resources.Persons_ManagePhoto,
    Actions.Execute
  ),
  ManageSignature: new SecurityAction(
    Resources.Persons_ManageSignature,
    Actions.Execute
  ),
  ManageSettings: new SecurityAction(
    Resources.Persons_ManageSettings,
    Actions.Execute
  ),
  ManageRelations: new SecurityAction(
    Resources.Persons_ManageRelations,
    Actions.Execute
  ),
  ManageAdministrations: new SecurityAction(
    Resources.Persons_ManageAdministrations, 
    Actions.Execute
  ),
  AccessToDocument: new SecurityAction(
    Resources.Persons_AccessToDocuments,
    Actions.Execute
  ),
  ManageLocationUsers: new SecurityAction(
    Resources.Persons_ManageLocationUsers, 
    Actions.Execute
  ),
  ManageSecurity: new SecurityAction(
    Resources.Persons_ManageSecurity, 
    Actions.Execute
  ),
  AccessToPersons: new SecurityAction(
    Resources.CentixWeb_AccessToPersons, 
    Actions.Execute
  )
};

export const Location = {
  Locations: new SecurityGroupAction(Resources.Locations)
};

export const MaintenanceInspection = new SecurityGroupAction(
  Resources.Objects_MaintenanceInspections
);
export const MaintenanceTeamRoles = new SecurityGroupAction(
  Resources.Maintenance_System_General_TeamRoles
);

export const Relation = {
  Relations: new SecurityGroupAction(Resources.Relations),
  AccessToProfile: new SecurityAction(Resources.Relations_AccessToProfile, Actions.Execute),
  AccessToInvoiceSettings: new SecurityAction(Resources.Relations_AccessToInvoiceSettings, Actions.Execute),
  AccessToFinancialSettings: new SecurityAction(Resources.Relations_AccessToFinancialSettings, Actions.Execute),
  Manage_Addresses: new SecurityAction(Resources.Relations_Manage_Addresses, Actions.Execute),
  Access_To_Order_Settings: new SecurityAction(Resources.Relations_Access_To_Order_Settings, Actions.Execute),
  Access_To_Purchase_Order_Settings: new SecurityAction(Resources.Relations_Access_To_Purchase_Order_Settings, Actions.Execute),
  Access_To_Web_Settings: new SecurityAction(Resources.Relations_Access_To_Web_Settings, Actions.Execute),
  ManageConcernRelations: new SecurityAction(Resources.Relations_ManageConcernRelations, Actions.Execute),
  ManageDocuments: new SecurityAction(Resources.Relations_ManageDocuments, Actions.Execute),
  BackOfficeRelations: new SecurityAction(Resources.CentixWeb_AccessToRelations, Actions.Execute),
  Relations_Dashboard: new SecurityAction(Resources.Relations_AccessDashboard, Actions.Execute),
	Relations_Access_To_Notification_Recipients: new SecurityAction(Resources.Relations_Access_To_Notification_Recipients, Actions.Execute)
};

export const ProcessNewUserRequests = {
  processNewUserRequests: new SecurityAction(
    Resources.CentixWeb_ProcessNewUserRequests,
    Actions.Execute
  )
};

export const ManageTeams= {
  ManageTeams: new SecurityAction(Resources.CentixSystemTables_ManageTeams, Actions.Execute)
};

export const Suppliers= {
  ManageSuppliers: new SecurityAction(Resources.CentixSystemTables_ManageSuppliers, Actions.Execute)
};

export const Mi = {
  ChangeInspectionCompanyInspector: new SecurityAction(Resources.ChangeInspectionCompanyInspector,Actions.Execute),
  AccessToLog: new SecurityAction(Resources.ObjectMI_AccessToLogs,Actions.Execute),
  ChangeMIScheduleTimeSchedule: new SecurityAction(Resources.ChangeMIScheduleTimeSchedule,Actions.Execute),
  AllowObjectConditionChange: new SecurityAction(Resources.MaintenanceInspection_AllowObjectConditionChange, Actions.Execute),
  AllowCertificateUpload: new SecurityAction(Resources.MaintenanceInspection_AllowCertificateUpload, Actions.Execute),
  AccessToDocuments: new SecurityAction(Resources.MaintenanceInspection_AccessToDocuments, Actions.Execute),
  ChangeInspectionLocation: new SecurityAction(Resources.ChangeInspectionLocation, Actions.Execute)
};

export const ManageBudgetCode= {
  BudgetCodes: new SecurityAction(Resources.CentixSystemTables_ManageBudgetCodes, Actions.Execute)
};

export const ManageObjectOIAutoResponseSettings= {
  ObjectOIAutoResponseSettings: new SecurityAction(Resources.CentixSystemTables_ManageObjectOIAutoResponseSettings, Actions.Execute)
};

export const Warehouses = {
  Manage_Warehouses: new SecurityGroupAction(Resources.Manage_Warehouses),
  Access_to_warehouses: new SecurityAction(Resources.Access_to_warehouses, Actions.Execute),
};


export const AccessToOrderBasket = new SecurityAction(Resources.Access_to_Orderbaskets, Actions.Execute);
export const OrderBasketOutstanding = new SecurityAction(Resources.AllowRentalOutstanding, Actions.Execute);
export const OrderBasketOrderUsers = new SecurityAction(Resources.AccessToOtherUsersOrderBaskets, Actions.Execute);
export const OrderBasket = {OrderBaskets: new SecurityGroupAction(Resources.OrderBaskets)};
export const OrderBasketAccessToProcessedOrderBaskets = {
  AccessToProcessedOrderBasket: new SecurityAction(Resources.AccessToProcessedOrderBaskets, Actions.Execute)
};
export const Document = new SecurityGroupAction(Resources.Documents);

 export const GenerateOrderPurchase = [
  new SecurityAction(Resources.PurchaseOrders_PurchaseOrder, Actions.CreateOrUpdate),
  new SecurityAction(Resources.Orders_Order, Actions.CreateOrUpdate)
];

export const PurchaseOrder = {
  PurchaseOrder: new SecurityGroupAction(Resources.PurchaseOrders_PurchaseOrder),
  AccessToConcept: new SecurityAction(Resources.PurchaseOrders_AccessToConcept, Actions.Execute),
  Concept_ChangeStatusToOrder : new SecurityAction(Resources.PurchaseOrders_Concept_ChangeStatusToOrder, Actions.Execute),
  Concept_ChangeStatusToOfferRequest: new SecurityAction(Resources.PurchaseOrders_Concept_ChangeStatusToOfferRequest, Actions.Execute),
  Concept_ChangeStatusToNotAuthorized: new SecurityAction(Resources.PurchaseOrders_Concept_ChangeStatusToNotAuthorized, Actions.Execute),
  AccessToOfferRequest: new SecurityAction(Resources.PurchaseOrders_AccessToOfferRequest, Actions.Execute),
  OfferRequest_ChangeStatusToOrder: new SecurityAction(Resources.PurchaseOrders_OfferRequest_ChangeStatusToOrder, Actions.Execute),
  OfferRequest_ChangeStatusToNotAuthorized: new SecurityAction(Resources.PurchaseOrders_OfferRequest_ChangeStatusToNotAuthorized, Actions.Execute),
  AccessToNotAuthorized: new SecurityAction(Resources.PurchaseOrders_AccessToNotAuthorized, Actions.Execute),
  NotAuthorized_ChangeStatusToAuthorized: new SecurityAction(Resources.PurchaseOrders_NotAuthorized_ChangeStatusToAuthorized, Actions.Execute),
  NotAuthorized_ChangeStatusToRefused: new SecurityAction(Resources.PurchaseOrders_NotAuthorized_ChangeStatusToRefused, Actions.Execute),
  AccessToOrder: new SecurityAction(Resources.PurchaseOrders_AccessToOrder, Actions.Execute),
  Order_ChangeStatusToBasket: new SecurityAction(Resources.PurchaseOrders_Order_ChangeStatusToBasket, Actions.Execute),
  Order_ChangeStatusToOfferRequest: new SecurityAction(Resources.PurchaseOrders_Order_ChangeStatusToOfferRequest, Actions.Execute),
  Order_ChangeStatusToNotAuthorized: new SecurityAction(Resources.PurchaseOrders_Order_ChangeStatusToNotAuthorized, Actions.Execute),
  AccessToCompleted: new SecurityAction(Resources.PurchaseOrders_AccessToCompleted, Actions.Execute),
  AccessToRefused: new SecurityAction(Resources.PurchaseOrders_AccessToRefused, Actions.Execute),
  Refused_ChangeStatusToNotAuthorized: new SecurityAction(Resources.PurchaseOrders_Refused_ChangeStatusToNotAuthorized, Actions.Execute),
  ManageReceipts: new SecurityAction(Resources.PurchaseOrders_ManageReceipts, Actions.Execute),
  AccessToWorkFlowItems: 
  [ 
      new SecurityAction(Resources.PurchaseOrders_AccessToWorkFlowItems, Actions.Execute),
      new SecurityAction(Resources.WorkFlows, Actions.Read)
  ],
  AccessToLogs: new SecurityAction(Resources.PurchaseOrders_AccessToLogs, Actions.Execute),
  AccessToDashboard: new SecurityAction(Resources.PurchaseOrders_AccessToDashboard, Actions.Execute),
  AccessToPurchaseOrders: new SecurityAction(Resources.CentixWeb_AccessToPurchaseOrders, Actions.Execute)
};

export const ManageUserAutoResponseSettings= {
  UserAutoResponseSettings: new SecurityAction(Resources.CentixSystemTables_ManageUserAutoResponseSettings, Actions.Execute)
};

export const MaintenanceSystemOrderTemplates = new SecurityGroupAction(
  Resources.Maintenance_System_OrderTemplates
);

export const ManageLocationTypes = {
  ManageLocationTypes: new SecurityAction(Resources.CentixSystemTables_ManageLocationTypes, Actions.Execute)
};

export const ManageReportDefinition = {
  ManageReportDefinitions: new SecurityAction(Resources.CentixSystemTables_ManageReportDefinitions, Actions.Execute)
};

export const ManageObjectTypes = {
  ManageObjectTypes: new SecurityAction(Resources.CentixSystemTables_ManageObjectTypes, Actions.Execute)
};

export const ManageMIPlans = {
  ManageMIPlans: new SecurityAction(Resources.CentixSystemTables_ManageMIPlans, Actions.Execute)
};

export const ManageMoveBasketAutoResponderSetting = {
  ManageMoveBasketAutoResponderSettings: new SecurityAction(Resources.CentixSystemTables_ManageMoveBasketAutoResponderSetting, Actions.Execute)
};

export const ManageObjectCode = {
  ManageObjectCodes: new SecurityAction(Resources.CentixSystemTables_ManageObjectCodes, Actions.Execute)
};

export const AccessToDatabaseSettings = { Read: new SecurityAction(Resources.Administrators_DatabaseSettings, Actions.Execute) };

export const AccessToWorkFlowPositionNumberCorrection = { Read: new SecurityAction(Resources.Administrators_WorkFlow_PositionNumber_Correction, Actions.Execute) };

export const ManageWorkableDay = {
  ManageWorkableDays: new SecurityAction(Resources.CentixSystemTables_ManageWorkableDays, Actions.Execute)
};

export const ManagePriceLists = {
  ManagePriceLists: new SecurityAction(Resources.CentixSystemTables_ManagePriceLists, Actions.Execute)
};

export const Journals = {
  Journal: new SecurityGroupAction(Resources.Journals),
  AccessToJournals: new SecurityAction(Resources.CentixWeb_AccessToJournals, Actions.Execute)
};

export const ManageAdministrations = {
  ManageAdministration : new SecurityAction(Resources.CentixSystemTables_ManageAdministrations, Actions.Execute)
};

export const ManageContractTypes = {
  ManageContractTypes : new SecurityAction(Resources.CentixSystemTables_ManageContractTypes, Actions.Execute)
};

export const ManageRelationContractAutoResponderSetting = {
  ManageRelationContractAutoResponderSettings: new SecurityAction(Resources.CentixSystemTables_ManageContractAutoresponseSettings, Actions.Execute)
};

export const ManageNewUserRequestsAutoResponseSetting = {
  ManageNewUserRequestsAutoResponseSettings: new SecurityAction(Resources.CentixSystemTables_ManageNewUserrequestsAutoresponseSettings, Actions.Execute)
};

export const ManagePurchaseOrderAutoResponseSetting = {
  ManagePurchaseOrderAutoResponseSettings: new SecurityAction(Resources.CentixSystemTables_ManagePurchaseOrderAutoresponseSettings, Actions.Execute)
};

export const ManageInvoiceAutoResponseSetting = {
  ManageInvoiceAutoResponseSettings: new SecurityAction(Resources.CentixSystemTables_ManageInvoiceAutoresponseSettings, Actions.Execute)
};

export const ManagePurchaseInvoiceAutoResponseSetting = {
  ManagePurchaseInvoiceAutoResponseSettings: new SecurityAction(Resources.CentixSystemTables_ManagePurchaseInvoiceAutoresponseSettings, Actions.Execute)
};

export const ManageFixedAssetGroup = {
  ManageFixedAssetGroups: new SecurityAction(Resources.CentixSystemTables_ManageManageFixedAssetGroups, Actions.Execute)
};

export const CopyObject = {
  CopyObjects: new SecurityAction(Resources.Objects_CopyObject, Actions.Execute)
};

export const PurchaseInvoices = {
  PurchaseInvoice: new SecurityGroupAction(Resources.PurchaseInvoices),
  ManagePurchaseInvoices : new SecurityAction(Resources.CentixWeb_AccessToPurchaseInvoices, Actions.Execute),
  AccessToWorkflow: new SecurityAction(Resources.PurchaseInvoices_AccessToWorkflow, Actions.Execute),
  AccessToDocuments: new SecurityAction(Resources.PurchaseInvoices_AccessToDocuments, Actions.Execute),
  AccessToLogs: new SecurityAction(Resources.PurchaseInvoices_AccessToLogs, Actions.Execute)
};

export const BookYears = {
  BookYear: new SecurityAction(Resources.CentixSystemTables_ManageBookYears, Actions.Execute)
};

export const ManageOrderCosts = {
  OrderCost: new SecurityAction(Resources.CentixSystemTables_ManageOrderCosts, Actions.Execute)
};

export const ManageTransportCosts = {
  TransportCost: new SecurityAction(Resources.CentixSystemTables_ManageTransportCosts, Actions.Execute)
};

export const ProductStockPurchase = {
  AccessToProductStockPurchase : new SecurityAction(Resources.CentixWeb_AccessToProductStockPurchase, Actions.Execute)
};
export const ManageBrandTypesRevisions ={ 
  ManageBrandTypesRevision : new SecurityAction(Resources.CentixSystemTables_ManageBrandTypesRevisions, Actions.Execute)} ;

export const AccessToReceipts = {  AccessToReceipt: new SecurityAction(    Resources.CentixWeb_AccessToReceipts,    Actions.Execute  )};

export const AccessToOrderTemplates = {  AccessToOrderTemplate: new SecurityAction(    Resources.CentixWeb_AccessToOrderTemplates,    Actions.Execute  )};

export const AccessToRecurringWorkFlowItems = new SecurityAction(Resources.CentixWeb_AccessToRecurringWorkFlowItems, Actions.Execute);

export const ManageLocationAutoResponderSetting = {
  ManageLocationAutoResponderSettings: new SecurityAction(Resources.CentixSystemTables_LocationAutoResponderSettings, Actions.Execute)
};

export const ManageWorkingTicketAutoResponderSetting = {
  ManageWorkingTicketAutoResponderSettings: new SecurityAction(Resources.CentixSystemTables_WorkingTicketAutoResponderSettings, Actions.Execute)
};

export const CapacityPlannings = {
  CapacityPlanning: new SecurityAction(Resources.CentixWeb_AccessToCapacityPlanning, Actions.Execute)
};

export const AllowExportUsingImportLayout = {
  ImportLayout: new SecurityAction(Resources.CentixWeb_AllowExportUsingImportLayout, Actions.Execute)
};

export const AllowExportUsingGridLayout = {
  GridLayout: new SecurityAction(Resources.CentixWeb_AllowExportUsingGridLayout, Actions.Execute)
};

export const ManageEmailTemplates = {
  ManageEmailTemplates: new SecurityAction(Resources.CentixSystemTables_ManageEmailTemplates, Actions.Execute)
};
export const ManageStockRevaluation = {
  StockRevaluations: new SecurityAction(Resources.Products_Manage_StockRevaluations, Actions.Execute)
};

export const AccessToProductStockRevaluation = {
  AccessToStockRevaluations: new SecurityAction(Resources.CentixWeb_AccessToProductStockRevaluation, Actions.Execute)
};

export const Competences = {
  Competence: new SecurityGroupAction(Resources.Competences),
};
export const AccessToCompetences = {
  AccessToCompetence: new SecurityAction(Resources.CentixWeb_AccessToCompetences, Actions.Execute)
};

export const ObjectMeterReadingSchedules = new SecurityGroupAction(Resources.Objects_MeterReadingSchedules);

export const ObjectMoveLogs = {
  ObjectMoveLog: new SecurityAction(Resources.Objects_MoveLogs, Actions.Execute)
};

export const ManageMeterreadings = {
  Meterreadings: new SecurityAction(Resources.CentixSystemTables_ManageMeterreadings, Actions.Execute)
};

export const ManageWorkflowGroups = {
  WorkflowGroups: new SecurityAction(Resources.CentixSystemTables_ManageWorkflowGroups, Actions.Execute)
};

export const ManageCountryStateCounties= {
  ManageCountryStateCounty: new SecurityAction(Resources.CentixSystemTables_ManageCountryStateCounty, Actions.Execute)
};

export const ManageLists= {
  ManageList: new SecurityAction(Resources.CentixSystemTables_ManageLists, Actions.Execute)
};

export const ManageWorkFlowAutoResponderSetting = {
  ManageWorkFlowAutoResponderSettings: new SecurityAction(Resources.CentixSystemTables_ManageWorkflowAutoresponderSettings, Actions.Execute)
};

export const ManageQuantitiesUnits = {
  QuantitiesUnits: new SecurityAction(Resources.CentixSystemTables_ManageQuantitiesUnits, Actions.Execute)
};

export const ManagePersonSystemSettings = {
  ManagePersonSystemSettings: new SecurityAction(Resources.CentixSystemSettings_ManagePersonSystemSettings, Actions.Execute)
};

export const ManageRelationSystemSettings = {
  ManageRelationSystemSettings: new SecurityAction(Resources.CentixSystemSettings_ManageRelationSystemSettings, Actions.Execute)
};

export const ManageInspectionNorms = {
  ManageInspectionNorm: new SecurityAction(Resources.CentixSystemTables_ManageInspectionNorm, Actions.Execute)
};

export const ManageVats = {
  ManageVat: new SecurityAction(Resources.CentixSystemTables_ManageVat, Actions.Execute)
};

export const ManageReasons = {
  ManageReason: new SecurityAction(Resources.CentixSystemTables_ManageReasons, Actions.Execute)
};

export const ManageReturnRequestAutoResponderSettings = {
  ManageReturnRequestAutoResponderSetting: new SecurityAction(Resources.CentixSystemTables_ManageReturnRequestAutoresponseSettings, Actions.Execute)
};

export const ManageWorkflowServiceLevels = {
  ManageWorkflowServiceLevel: new SecurityAction(Resources.CentixSystemTables_ManageWorkflowServiceLevel, Actions.Execute)
};

export const ReturnRequests = {
  ReturnRequests: new SecurityGroupAction(Resources.ReturnRequests),
  AccessToConcept: new SecurityAction(Resources.ReturnRequests_AccessToConcept, Actions.Execute),
  ChangeConceptToSubmitted: new SecurityAction(Resources.ReturnRequests_ChangeConceptToSubmitted, Actions.Execute),
  AccessToSubmitted: new SecurityAction(Resources.ReturnRequests_AccessToSubmitted, Actions.Execute),
  ChangeSubmittedToAccepted: new SecurityAction(Resources.ReturnRequests_ChangeSubmittedToAccepted, Actions.Execute),
  ChangeSubmittedToDenied: new SecurityAction(Resources.ReturnRequests_ChangeSubmittedToDenied, Actions.Execute),
  ChangeSubmittedToCancelled: new SecurityAction(Resources.ReturnRequests_ChangeSubmittedToCancelled, Actions.Execute),
  ChangeAcceptedToConcept: new SecurityAction(Resources.ReturnRequests_ChangeAcceptedToConcept, Actions.Execute),
  ChangeAcceptedToCancelled: new SecurityAction(Resources.ReturnRequests_ChangeAcceptedToCancelled, Actions.Execute),
  AccessToDenied: new SecurityAction(Resources.ReturnRequests_AccessToDenied, Actions.Execute),
  ChangeDeniedToConcept: new SecurityAction(Resources.ReturnRequests_ChangeDeniedToConcept, Actions.Execute),
  ChangeDeniedToCancelled: new SecurityAction(Resources.ReturnRequests_ChangeDeniedToCancelled, Actions.Execute),
  AccessToCancelled: new SecurityAction(Resources.ReturnRequests_AccessToCancelled, Actions.Execute),
  AccessToReturnRequests: new SecurityAction(Resources.CentixWeb_AccessToReturnRequests, Actions.Execute)
};

export const ManageLogSettings = {
  ManageLogSetting: new SecurityAction(Resources.Administrators_ManageLogSettings, Actions.Execute)
};

export const ManageWorkFlowPriorities= {
  ManageWorkFlowPriority: new SecurityAction(Resources.CentixSystemTables_ManageWorkFlowPriority, Actions.Execute)
};

export const ManageWorkingTicketSystemSettings = {
  ManageWorkingTicketSystemSetting: new SecurityAction(Resources.CentixSystemSettings_ManageWorkingTicketSystemSettings, Actions.Execute)
};
export const ManageWorkFlowSystemSettings = {
  ManageWorkFlowSystemSetting: new SecurityAction(Resources.CentixSystemSettings_ManageWorkFlowSystemSettings, Actions.Execute)
};


export const ManageOrderSystemSettings = {
  ManageOrderSystemSetting: new SecurityAction(Resources.CentixSystemSettings_ManageOrderSystemSettings, Actions.Execute)
};

export const ManageContractIndexes= {
  ManageContractIndex: new SecurityAction(Resources.CentixSystemTables_ManageContractIndex, Actions.Execute)
};

export const ObjectDetail = {
  Object: Object,
  Objects_ChangeMedia: new SecurityAction(Resources.Objects_ChangeMedia, Actions.Execute),
  Objects_ChangeImage: new SecurityAction(Resources.Objects_ChangeImage, Actions.Execute),
  Objects_ChangeObjectMIPlanSchemes: new SecurityAction(Resources.Objects_ChangeObjectMIPlanSchemes, Actions.Execute),
  Objects_Attach_Object: new SecurityAction(Resources.Objects_Attach_Object, Actions.Execute),
  Objects_Measurements: new SecurityAction(Resources.Objects_Measurements, Actions.Execute),
  MoveBasket: new SecurityGroupAction(Resources.MoveBasket)
};

export const ManagePackListAutoResponderSettings = {
  ManagePackListAutoResponderSetting: new SecurityAction(Resources.CentixSystemTables_ManagePackListAutoResponderSetting, Actions.Execute)
};

export const ManageReturnListAutoResponderSettings = {
  ManageReturnListAutoResponderSetting: new SecurityAction(Resources.CentixSystemTables_ManageReturnListAutoResponderSetting, Actions.Execute)
};

export const ManageMIWorkFlowSettings = {
  ManageMIWorkFlowSetting: new SecurityAction(Resources.CentixSystemTables_ManageMIWorkFlowSetting, Actions.Execute)
};

export const ManageOrderAutoResponderSettings = {
  ManageOrderAutoResponderSetting: new SecurityAction(Resources.CentixSystemTables_ManageOrderAutoResponderSetting, Actions.Execute)
};

export const AccessToEInvoices = {
  AccessToEInvoice: new SecurityAction(Resources.CentixWeb_AccessToEInvoices, Actions.Execute)
};

export const Movebasket = {
  Movebasket : new SecurityGroupAction(Resources.MoveBasket),
  AccessToOtherUsersMovebaskets: new SecurityAction(Resources.AccessToOtherUsersMovebaskets,Actions.Execute),
  AccessToProcessedMovebaskets: new SecurityAction(Resources.AccessToProcessedMovebaskets,Actions.Execute),
  AccessToLogs: new SecurityAction(Resources.AccessToLogs,Actions.Execute),
  AccessToDocuments: new SecurityAction(Resources.AccessToDocuments,Actions.Execute),
};

export const ManageLocationStatuses = {
  ManageLocationStatus: new SecurityAction(Resources.CentixSystemTables_ManageLocationStatuses, Actions.Execute)
};

export const ManageProductStatuses = {
  ManageProductStatus: new SecurityAction(Resources.CentixSystemTables_ManageProductStatuses, Actions.Execute)
};

export const ManageTransportMethods = {
  ManageTransportMethods: new SecurityAction(Resources.CentixSystemTables_ManageTransportMethod, Actions.Execute)
};

export const ManagePersonStatuses = {
  ManagePersonStatus: new SecurityAction(Resources.CentixSystemTables_ManagePersonStatuses, Actions.Execute)
};

export const ManageProjectStatuses = {
  ManageProjectStatus: new SecurityAction(Resources.CentixSystemTables_ManageProjectStatuses, Actions.Execute)
};

export const ManageRelationStatuses = {
  ManageRelationStatus: new SecurityAction(Resources.CentixSystemTables_ManageRelationStatuses, Actions.Execute)
};

export const DistributionBoards = {
  DistributionBoards: new SecurityAction(Resources.DistributionBoards, Actions.Execute),
  OtherPeoplesDistributionBoards: new SecurityAction(Resources.OtherPeoplesDistributionBoards, Actions.Execute)
};

export const ManageObjectStatuses = {
  ManageObjectStatus: new SecurityAction(Resources.CentixSystemTables_ManageObjectStatuses, Actions.Execute)
};

export const ManageRelationContractStatuses = {
  ManageRelationContractStatus: new SecurityAction(Resources.CentixSystemTables_ManageRelationContractStatuses, Actions.Execute)
};

export const AccessToDepreciations = {
  AccessToDepreciation: new SecurityAction(Resources.CentixWeb_AccessToDepreciations, Actions.Execute)
};

export const AccessToStocks = {
  AccessToStock: new SecurityAction(Resources.CentixWeb_AccessToStocks, Actions.Execute)
};
export const ManageDocumentKinds = {
  ManageDocumentKind: new SecurityAction(Resources.CentixSystemTables_ManageDocumentKinds, Actions.Execute)
};

export const MovePos = {
  AccessToMovePos: new SecurityAction(Resources.CentixWeb_AccessToMovePos, Actions.Execute)
};
export const ManageMovePos = {
  MovePos: new SecurityAction(Resources.CentixSystemTables_ManageMovePos, Actions.Execute)
};

export const LocationDetail = {
  Location: Location.Locations,
  Locations_ChangeMedia: new SecurityAction(Resources.Locations_ChangeMedia, Actions.Execute),
  Locations_ChangeImage: new SecurityAction(Resources.Locations_ChangeImage, Actions.Execute),
  Locations_LocationUsers: new SecurityAction(Resources.Locations_LocationUsers, Actions.Execute),
};
export const AccessToProductRealizations = {
  AccessToProductRealization: new SecurityAction(Resources.CentixWeb_AccessToProductRealizations, Actions.Execute)
};

export const ManageFormConfigurations = {
  ManageFormConfiguration: new SecurityAction(Resources.CentixSystemTables_ManageFormConfigurations, Actions.Execute)
};

export const ManageMeasuringDeviceBrandAndType =  new SecurityAction(Resources.CentixSystemTables_ManageMeasuringDeviceBrandAndType, Actions.Execute);

export const ObjectsMeasurements =  new SecurityAction(Resources.Objects_Measurements, Actions.Execute);

export const ShoppingCart = {
  Order: new SecurityGroupAction(Resources.Orders_Order),
  AccessToBaskets: new SecurityAction(Resources.AccessToBaskets)
};

export const ManageProjectAutoResponderSetting =  new SecurityAction(Resources.CentixSystemTables_ManageProjectAutoResponderSetting, Actions.Execute);

export const Devices = {
  Activate: new SecurityAction (Resources.Administrators_AuthorisedToSign, Actions.Execute)
};

export const ManageHourKinds = {
  ManageHourKind: new SecurityAction(Resources.CentixSystemTables_ManageHourkind, Actions.Execute)
};
export const ManagePropertyGroups = new SecurityAction(Resources.CentixSystemTables_ManagePropertyGroups, Actions.Execute);
export const ManageArticleUnits = new SecurityAction(Resources.CentixSystemTables_ManageArticleUnits, Actions.Execute);
export const ManageContentLanguages = new SecurityAction(Resources.Administrators_ContentLanguages, Actions.Execute);


export const IoT = {
  IoT_ManageDevices: new SecurityAction(Resources.IoT_ManageDevices, Actions.Execute),
  IoT_Geofences: new SecurityGroupAction(Resources.IoT_Geofences),
  CentixWeb_AccessToDevices: new SecurityAction(Resources.CentixWeb_AccessToDevices, Actions.Execute)
};
export const ManageWorkPlaces= {
  WorkPlace: new SecurityAction(Resources.CentixSystemTables_ManageWorkPlace, Actions.Execute)
};

export const ManageRentalRateCodes = new SecurityAction(Resources.CentixSystemTables_ManageRentalRateCode, Actions.Execute);

export const ObjectsAccessToNotificationRecipients = new SecurityAction(Resources.Objects_Access_To_Notification_Recipients, Actions.Execute);
export const LocationsAccessToNotificationRecipients = new SecurityAction(Resources.Locations_Access_To_Notification_Recipients, Actions.Execute);
export const AccessToObjectAlertEmails = new SecurityAction(Resources.CentixWeb_Access_To_ObjectAlert_Emails, Actions.Execute);

export const ManageCrossLinkTypes = new SecurityAction(Resources.CentixSystemTables_ManageCrossLinkTypes, Actions.Execute);

export const ManageObjectIDGenerators = new SecurityAction(Resources.CentixSystemTables_ManageIDGeneratorSettings, Actions.Execute);

export const RecurringWorkFlow = {
  RecurringWorkFlowItems: new SecurityGroupAction(Resources.RecurringWorkFlow),
  AccessToHourCalculation: new SecurityAction(Resources.RecurringWorkFlow_AccessToHourCalculations, Actions.Execute),
  AccessToWorkFlow: new SecurityAction(Resources.RecurringWorkFlow_AccessToWorkFlow, Actions.Execute),
  AccessToDocuments: new SecurityAction(Resources.RecurringWorkFlow_AccessToDocuments, Actions.Execute),
 };

 export const WorkflowTemplates = {
  WorkflowTemplateItems: new SecurityGroupAction(Resources.WorkflowTemplate),
  AccessToHourCalculation: new SecurityAction(Resources.WorkflowTemplate_AccessToHourCalculations, Actions.Execute),
  AccessToWorkFlow: new SecurityAction(Resources.WorkflowTemplate_AccessToWorkFlow, Actions.Execute),
  AccessToDocuments: new SecurityAction(Resources.WorkflowTemplate_AccessToDocuments, Actions.Execute),
 };

 export const AccessToWorkflowTemplates = new SecurityAction(Resources.AccessToWorkflowTemplates, Actions.Execute);


export const ManageWebPages = new SecurityAction(Resources.Administrators_ManageWebPages, Actions.Execute);

export const ManageObjectGroups = new SecurityAction(Resources.CentixSystemTables_ManageObjectGroups, Actions.Execute);
export const ManageConditions = new SecurityAction(Resources.CentixSystemTables_ManageConditions, Actions.Execute);
export const ManageLockReasons = new SecurityAction(Resources.CentixSystemTables_ManageLockReasons, Actions.Execute);

export const ManageTimeSchedules = new SecurityAction(Resources.CentixSystemTables_ManageTimeSchedules, Actions.Execute);
export const ManageLocationIDGenerators = new SecurityAction(Resources.CentixSystemTables_ManageLocationIDGeneratorSettings, Actions.Execute);
export const ManageCompetences = new SecurityAction(Resources.CentixSystemTables_ManageCompetences, Actions.Execute);

export const AccessToDocuments = new SecurityAction(Resources.CentixWeb_Access_To_Documents, Actions.Execute);

export const ManageAddressGroups = new SecurityAction(Resources.CentixSystemTables_ManageAddressGroups, Actions.Execute);
export const ManageBlockReasons = new SecurityAction(Resources.CentixSystemTables_ManageBlockReasons, Actions.Execute);
export const ManageLanguages = new SecurityAction(Resources.CentixSystemTables_ManageLanguages, Actions.Execute);
export const ManageSystemSecurityGroups = new SecurityAction(Resources.Administrators_Security_Groups, Actions.Execute);
export const ManagePaymentMethods = new SecurityAction(Resources.CentixSystemTables_ManagePaymentMethods, Actions.Execute);
export const ManagePaymentConditions = new SecurityAction(Resources.CentixSystemTables_ManagePaymentConditions, Actions.Execute);
export const ManageRelationGroups = new SecurityAction(Resources.CentixSystemTables_ManageRelationGroups, Actions.Execute);
export const ManageFlowStatuses = new SecurityAction(Resources.CentixSystemTables_ManageFlowStatuses, Actions.Execute);
export const ManageWorkingTicketStatus = new SecurityAction(Resources.CentixSystemTables_ManageWorkingTicketStatusses, Actions.Execute);
